import { PureComponent } from 'react'
import { connect } from 'react-redux'
import { func } from 'prop-types'
import { getCategories, getSubCategories } from '../../store/Actions/SpiActions'

class SignCategories extends PureComponent {
  componentDidMount = () => {
    this.props.getCategories()
    this.props.getSubCategories()
  }

  render() {
    return this.props.children
  }
}

SignCategories.propTypes = {
  getCategories: func.isRequired,
  getSubCategories: func.isRequired,
}

const mapDispatchToProps = dispatch => ({
  getCategories: () => dispatch(getCategories()),
  getSubCategories: () => dispatch(getSubCategories()),
})

export default connect(null, mapDispatchToProps)(SignCategories)
